import Section from "../components/Section";

export default function Contact() {
  return (
    <Section eyebrow="Contact" title="Get in Touch" subtitle="For corrections or suggestions (student project).">
      <a className="text-rose-700 font-medium" href="mailto:knowthalassemia.project@gmail.com">
        knowthalassemia.project@gmail.com
      </a>
      <p className="text-xs text-slate-500 mt-3">
        We do not provide medical advice. Please contact qualified healthcare professionals for medical questions.
      </p>
    </Section>
  );
}
